import {
    POST_TIGERCAT_BURNS_CREATE_CAR_RPPB_SUCCESS,
    POST_TIGERCAT_BURNS_CREATE_CAR_RPPB_FAIL,
    GET_TIGERCAT_BURNS_GET_COMPANY_USER_CAR_RPPBS_SUCCESS,
    GET_TIGERCAT_BURNS_GET_COMPANY_USER_CAR_RPPBS_FAIL,
    POST_TIGERCAT_BURNS_CREATE_CAR_RPPB_PROJECT_SUCCESS,
    POST_TIGERCAT_BURNS_CREATE_CAR_RPPB_PROJECT_FAIL,
    GET_TIGERCAT_BURNS_GET_CAR_RPPB_PROJECTS_SUCCESS,
    GET_TIGERCAT_BURNS_GET_CAR_RPPB_PROJECTS_FAIL,
    GET_TIGERCAT_BURNS_GET_USERS_SUCCESS,
    GET_TIGERCAT_BURNS_GET_USERS_FAIL,
    POST_TIGERCAT_BURNS_CREATE_BIOCHAR_BINS_SUCCESS,
    POST_TIGERCAT_BURNS_CREATE_BIOCHAR_BINS_FAIL,
    GET_TIGERCAT_BURNS_GET_USER_BIOCHAR_BINS_SUCCESS,
    GET_TIGERCAT_BURNS_GET_USER_BIOCHAR_BINS_FAIL,
    POST_TIGERCAT_BURNS_CREATE_BIOCHAR_EQUIPMENT_SUCCESS,
    POST_TIGERCAT_BURNS_CREATE_BIOCHAR_EQUIPMENT_FAIL,
    GET_TIGERCAT_BURNS_GET_USER_BIOCHAR_EQUIPMENT_SUCCESS,
    GET_TIGERCAT_BURNS_GET_USER_BIOCHAR_EQUIPMENT_FAIL,
    GET_TIGERCAT_BURNS_GET_PROJECTS_FOR_USER_SUCCESS,
    GET_TIGERCAT_BURNS_GET_PROJECTS_FOR_USER_FAIL,
    PATCH_TIGERCAT_BURNS_ASSIGN_ASSET_TO_PROJECT_SUCCESS,
    PATCH_TIGERCAT_BURNS_ASSIGN_ASSET_TO_PROJECT_FAIL,
    GET_TIGERCAT_BURNS_GET_ALL_PROJECTS_WITH_ASSIGNED_ASSETS_SUCCESS,
    GET_TIGERCAT_BURNS_GET_ALL_PROJECTS_WITH_ASSIGNED_ASSETS_FAIL,
    PATCH_TIGERCAT_BURNS_UNASSIGN_ASSET_FROM_PROJECT_SUCCESS,
    PATCH_TIGERCAT_BURNS_UNASSIGN_ASSET_FROM_PROJECT_FAIL,
    API_GET_TABLE_TOTAL_RECORD_COUNT_SUCCESS,
    API_GET_TABLE_TOTAL_RECORD_COUNT_FAIL,
    API_PROJECT_DESCRIPTION_SUCCESS,
    API_PROJECT_DESCRIPTION_FAIL,
    API_ROLES_AND_RESPONSIBILITIES_SUCCESS,
    API_ROLES_AND_RESPONSIBILITIES_FAIL,
    API_TIGERCAT_BURNS_EQUIPMENT_MAINTENANCE_FAIL,
    API_TIGERCAT_BURNS_EQUIPMENT_MAINTENANCE_SUCCESS,
    API_GET_UPLOADED_DOCUMENTS_SUCCESS,
    API_GET_UPLOADED_DOCUMENTS_FAIL
} from '../../actions/tigercat-burns/types/tigercat-base-types';

const initialState = {
    loading: true,
    carRppbs: [],
    carRppbProjects: [],
    tigercatBurnsUsers: [],
    userBins: [],
    userEquipment: [],
    userProjects: [],
    projectsWithAssignedAssets: [],
    projectDescription: [],
    rolesAndResponsibilities: [],
    totalRecordCount: 0,
    equipmentMaintenance: [],
    uploadedDocuments: [],
    error: []
};

export default function tigercatBurnsBaseReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case POST_TIGERCAT_BURNS_CREATE_CAR_RPPB_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case POST_TIGERCAT_BURNS_CREATE_CAR_RPPB_FAIL:
            return {
                ...state,
                loading: false
            }
        case GET_TIGERCAT_BURNS_GET_COMPANY_USER_CAR_RPPBS_SUCCESS:
            return {
                ...state,
                loading: false,
                carRppbs: payload
            };
        case GET_TIGERCAT_BURNS_GET_COMPANY_USER_CAR_RPPBS_FAIL:
            return {
                ...state,
                loading: false
            }
        case POST_TIGERCAT_BURNS_CREATE_CAR_RPPB_PROJECT_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case POST_TIGERCAT_BURNS_CREATE_CAR_RPPB_PROJECT_FAIL:
            return {
                ...state,
                loading: false
            }
        case GET_TIGERCAT_BURNS_GET_CAR_RPPB_PROJECTS_SUCCESS:
            return {
                ...state,
                loading: false,
                carRppbProjects: payload
            };
        case GET_TIGERCAT_BURNS_GET_CAR_RPPB_PROJECTS_FAIL:
            return {
                ...state,
                loading: false
            }
        case GET_TIGERCAT_BURNS_GET_USERS_SUCCESS:
            return {
                ...state,
                loading: false,
                tigercatBurnsUsers: payload
            };
        case GET_TIGERCAT_BURNS_GET_USERS_FAIL:
            return {
                ...state,
                loading: false
            }
        case POST_TIGERCAT_BURNS_CREATE_BIOCHAR_BINS_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case POST_TIGERCAT_BURNS_CREATE_BIOCHAR_BINS_FAIL:
            return {
                ...state,
                loading: false
            }
        case GET_TIGERCAT_BURNS_GET_USER_BIOCHAR_BINS_SUCCESS:
            return {
                ...state,
                loading: false,
                userBins: payload
            };
        case GET_TIGERCAT_BURNS_GET_USER_BIOCHAR_BINS_FAIL:
            return {
                ...state,
                loading: false
            }
        case POST_TIGERCAT_BURNS_CREATE_BIOCHAR_EQUIPMENT_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case POST_TIGERCAT_BURNS_CREATE_BIOCHAR_EQUIPMENT_FAIL:
            return {
                ...state,
                loading: false
            }
        case GET_TIGERCAT_BURNS_GET_USER_BIOCHAR_EQUIPMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                userEquipment: payload
            };
        case GET_TIGERCAT_BURNS_GET_USER_BIOCHAR_EQUIPMENT_FAIL:
            return {
                ...state,
                loading: false
            }
        case GET_TIGERCAT_BURNS_GET_PROJECTS_FOR_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                userProjects: payload
            };
        case GET_TIGERCAT_BURNS_GET_PROJECTS_FOR_USER_FAIL:
            return {
                ...state,
                loading: false
            }
        case PATCH_TIGERCAT_BURNS_ASSIGN_ASSET_TO_PROJECT_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case PATCH_TIGERCAT_BURNS_ASSIGN_ASSET_TO_PROJECT_FAIL:
            return {
                ...state,
                loading: false
            }
        case PATCH_TIGERCAT_BURNS_UNASSIGN_ASSET_FROM_PROJECT_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case PATCH_TIGERCAT_BURNS_UNASSIGN_ASSET_FROM_PROJECT_FAIL:
            return {
                ...state,
                loading: false
            }
        case GET_TIGERCAT_BURNS_GET_ALL_PROJECTS_WITH_ASSIGNED_ASSETS_SUCCESS:
            return {
                ...state,
                loading: false,
                projectsWithAssignedAssets: payload
            };
        case GET_TIGERCAT_BURNS_GET_ALL_PROJECTS_WITH_ASSIGNED_ASSETS_FAIL:
            return {
                ...state,
                loading: false
            }
        case API_GET_TABLE_TOTAL_RECORD_COUNT_SUCCESS:
            return {
                ...state,
                loading: false,
                totalRecordCount: payload
            };
        case API_GET_TABLE_TOTAL_RECORD_COUNT_FAIL:
            return {
                ...state,
                loading: false
            }
        case API_PROJECT_DESCRIPTION_SUCCESS:
            return {
                ...state,
                loading: false,
                projectDescription: payload
            };
        case API_PROJECT_DESCRIPTION_FAIL:
            return {
                ...state,
                loading: false,
                projectDescription: payload
            }
        case API_ROLES_AND_RESPONSIBILITIES_SUCCESS:
            return {
                ...state,
                loading: false,
                rolesAndResponsibilities: payload
            };
        case API_ROLES_AND_RESPONSIBILITIES_FAIL:
            return {
                ...state,
                loading: false,
                rolesAndResponsibilities: payload
            }
        case API_TIGERCAT_BURNS_EQUIPMENT_MAINTENANCE_SUCCESS:
            return {
                ...state,
                loading: false,
                equipmentMaintenance: payload
            };
        case API_TIGERCAT_BURNS_EQUIPMENT_MAINTENANCE_FAIL:
            return {
                ...state,
                loading: false,
                error: payload
            }
        case API_GET_UPLOADED_DOCUMENTS_SUCCESS:
            return {
                ...state,
                loading: false,
                uploadedDocuments: payload
            };
        case API_GET_UPLOADED_DOCUMENTS_FAIL:
            return {
                ...state,
                loading: false,
                uploadedDocuments: payload
            }
        default:
            return state;
    }
}
